<div class="dialog-container overflow">

    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
                    <path fill="currentColor" fill-rule="evenodd"
                        d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0"
                        clip-rule="evenodd" />
                </svg>
            </div>
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>

    <!-- 
    <section mat-dialog-title>
        <div class="d-flex justify-content-between fw-500 fs-17" style="width: 100%; display: flex;">
            <span class="heading-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="currentColor"
                        d="M11.5 4a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7M6 7.5a5.5 5.5 0 1 1 11 0a5.5 5.5 0 0 1-11 0M19 13v4h4v2h-4v4h-2v-4h-4v-2h4v-4zM8 16a4 4 0 0 0-4 4h8.05v2H2v-2a6 6 0 0 1 6-6h4v2z" />
                </svg>
            </span>
            <ng-container *ngIf="!memberId; else editNote">
                <span class="heading mt-2" style="flex-grow: 1;">
                    @if(renderForm == RenderFrom.REQUEST){
                    Request ME
                    }
                    @else{
                    Add Member
                    }
                </span>
            </ng-container>
            <ng-template #editNote>
                @if(renderForm == RenderFrom.REQUEST){
                <span class="heading mt-2" style="flex-grow: 1;">Request ME</span>
                }
                @else {
                <span class="heading mt-2" style="flex-grow: 1;">Edit Member</span>
                }
            </ng-template>
        </div>
    </section> -->

    <section mat-dialog-content>
        <form [formGroup]="patientForm">
            <div class="form-container">

                @if (renderForm === RenderFrom.REQUEST) {
                @if(!memberIdFromParent){

                <!-- <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Search Member</mat-label>
                        <input type="text" matInput [matAutocomplete]="auto" [formControl]="memberSearchControl"
                            [placeholder]="'Enter at least 3 characters to search'" />

                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPatientName"
                            (optionSelected)="onMemberSelected($event.option.value)">

                            <mat-option *ngFor="let patient of filteredPatients" [value]="patient">
                                <div class="patient-info">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                        viewBox="0 0 256 256">
                                        <path fill="#bbb5b5"
                                            d="M128 28a100 100 0 1 0 100 100A100.11 100.11 0 0 0 128 28M68.87 198.42a68 68 0 0 1 118.26 0a91.8 91.8 0 0 1-118.26 0m124.3-5.55a75.6 75.6 0 0 0-44.51-34a44 44 0 1 0-41.32 0a75.6 75.6 0 0 0-44.51 34a92 92 0 1 1 130.34 0M128 156a36 36 0 1 1 36-36a36 36 0 0 1-36 36"
                                            stroke-width="1.5" stroke="#bbb5b5" />
                                    </svg>
                                    <div class="text-content">
                                        <div class="fs-13">
                                            {{ patient.firstName }} {{ patient.lastName }}
                                            <span *ngIf="patient.nhsNumber" class="fs-10 gray-text"
                                                style="color:rgb(101, 101, 248)">
                                                (#{{ patient.nhsNumber }})
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>



                <div class="d-flex">
                    <span class="mb-5 text-muted fs-14">
                        * Please select the member above or alternatively enter the details below to request for medical
                        evidence
                    </span>
                </div> -->

                }
                @else {
                <!-- patient info -->

                @if(selectedPatient){

                <span class="fs-13 fw-600">Applicant Details</span>

                <div class="patient-card p-3 mt-2 mb-4 rounded shadow-sm">
                    <div class="d-flex align-items-center gap-3">
                        <div class="avatar-box d-flex align-items-center justify-content-center rounded-circle">
                            <span class="fs-14 fw-500">{{selectedPatient.firstName | initials :
                                selectedPatient.lastName}}</span>
                        </div>
                        <div class="flex-grow-1">
                            <div class="fs-14 fw-500">{{ selectedPatient.firstName }} {{ selectedPatient.lastName }}
                            </div>
                            <div class="text-muted fs-12 mt-1">{{ selectedPatient.dateOfBirth | age }}, {{
                                selectedPatient.gender.charAt(0) }}</div>
                        </div>

                        <div class="vertical-separator">
                        </div>

                        <div class="d-flex flex-column align-items-end gap-1">
                            <div class="d-flex align-items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none"
                                    viewBox="0 0 24 24">
                                    <path fill="#0075C9"
                                        d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
                                </svg>
                                <span class="fs-14" style="color:#222;">{{ selectedPatient.phone }}</span>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none"
                                    viewBox="0 0 24 24">
                                    <path fill="#0075C9"
                                        d="M5 5h13a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m0 1c-.5 0-.94.17-1.28.47l7.78 5.03l7.78-5.03C18.94 6.17 18.5 6 18 6zm6.5 6.71L3.13 7.28C3.05 7.5 3 7.75 3 8v9a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V8c0-.25-.05-.5-.13-.72z" />
                                </svg>
                                <span class="fs-14" style="color:#222;">{{ selectedPatient.email }}</span>
                                <span class="copy-icon ms-1" style="cursor:pointer;"
                                    (click)="copyToClipboard(selectedPatient.email)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="#1976d2"
                                            d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                                    </svg>
                                </span>
                                <span *ngIf="copiedEmail === selectedPatient.email" class="copied-text ms-1">
                                    Copied!
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                }
                }

                }


                <!-- Row: First Name + Last Name -->
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>First Name</mat-label>
                        <input type="text" matInput formControlName="firstName" required>
                        <mat-error *ngIf="patientForm.get('firstName')?.hasError('required')">
                            First Name is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Last Name</mat-label>
                        <input type="text" matInput formControlName="lastName" required>
                        <mat-error *ngIf="patientForm.get('lastName')?.hasError('required')">
                            Last Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Row: Date of Birth + Gender -->
                <div class="form-row">

                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth" [max]="today"
                            required>
                        <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dobPicker></mat-datepicker>

                        <mat-error *ngIf="patientForm.get('dateOfBirth')?.hasError('required')">
                            Date of Birth is required
                        </mat-error>
                        <mat-error *ngIf="patientForm.get('dateOfBirth')?.errors?.['matDatepickerParse']?.text">
                            Invalid date format
                        </mat-error>
                    </mat-form-field>


                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Gender</mat-label>
                        <mat-select formControlName="gender" required>
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                            <mat-option value="Prefer not to say">Prefer not to say</mat-option>
                        </mat-select>
                        <mat-error *ngIf="patientForm.get('gender')?.hasError('required')">
                            Gender is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Row: Email + Phone Number -->
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Email</mat-label>
                        <input type="email" matInput formControlName="email" type="email" required>
                        <mat-error *ngIf="patientForm.get('email')?.hasError('required')">
                            Email is required
                        </mat-error>
                        <mat-error *ngIf="patientForm.get('email')?.hasError('email')">
                            Invalid email address
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone" required placeholder="+44 7123 456789">
                        <mat-error *ngIf="patientForm.get('phone')?.hasError('required')">
                            Phone Number is required
                        </mat-error>
                        <mat-error *ngIf="patientForm.get('phone')?.hasError('pattern')">
                            Invalid phone number
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Row: Address + National Insurance Number -->
                <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Address</mat-label>
                        <input type="text" matInput formControlName="address" required>
                        <mat-error *ngIf="patientForm.get('address')?.hasError('required')">
                            Address is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>NI Number</mat-label>
                        <input matInput formControlName="nhsNumber">
                    </mat-form-field>
                </div>

                @if (renderForm === RenderFrom.REQUEST) {

                <span class="mb-2 fs-14 fw-600"  aria-required="true" *ngIf="addedProvidersList.length > 0"   >
                    The below provider has been assigned to handle the request
                </span>

                <span class="mb-2 fs-14 text-danger" *ngIf="addedProvidersList.length == 0">
                    * No provider has been assigned to manage the medical evidence.
                </span>

                <div class="provider-selection">
                    <div class="provider-card" *ngFor="let provider of addedProvidersList; let i = index"
                        [class.selected]="provider.id===selectedProviderId" (click)="selectProvider(provider.id)" >
                        <div class="patient-avatar">
                            <ng-container *ngIf="provider.imgLogoUrl; else defaultIcon">
                                <img [src]="provider.imgLogoUrl" alt="{{provider.name}}" />
                            </ng-container>

                            <ng-template #defaultIcon>
                                <span class="icon-btn" style="padding: 12px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                        viewBox="0 0 256 256">
                                        <path fill="#757474"
                                            d="M248 212h-12v-84a12 12 0 0 0-12-12h-60V48a12 12 0 0 0-12-12H56a12 12 0 0 0-12 12v164H32a4 4 0 0 0 0 8h216a4 4 0 0 0 0-8m-24-88a4 4 0 0 1 4 4v84h-64v-88ZM52 48a4 4 0 0 1 4-4h96a4 4 0 0 1 4 4v164h-24v-52a4 4 0 0 0-4-4H80a4 4 0 0 0-4 4v52H52Zm72 164H84v-48h40ZM76 96a4 4 0 0 1 4-4h20V72a4 4 0 0 1 8 0v20h20a4 4 0 0 1 0 8h-20v20a4 4 0 0 1-8 0v-20H80a4 4 0 0 1-4-4"
                                            stroke-width="1.5" stroke="#757474" />
                                    </svg>
                                </span>

                            </ng-template>
                        </div>

                        <div class="provider-info">
                            <h4>{{ provider.tradingName }}</h4>
                            <p><span class="gray-text fs-12">Specialties :</span> {{ provider.speciality }}</p>
                        </div>
                    </div>
                    <div class="provider-card">
                        <div class="patient-avatar">
                            <ng-container>
                                <img src="../../../../../assets/images/med.jpg" alt="Medipartner"/>
                            </ng-container>
                        </div>

                        <div class="provider-info">
                            <h4>Medipartner</h4>
                            <p><span class="gray-text fs-12">Specialties :</span> All Specialities</p>
                        </div>
                    </div>
                </div>
                }

                <span class="fs-12" style="color: #000000e3">Comments</span>

                <div class="form-row mt-2">
                    <mat-form-field appearance="outline" class="form-field" style="height: 75px;">
                        <textarea matInput formControlName="comments"></textarea>
                    </mat-form-field>
                </div>


                <span class="fs-12" style="color: #000000e3" aria-required="true" >Upload Documents</span>

                <div class="form-field-container w-100 mt-2 mb-3">

                    <div class="fileupload-container d-flex w-100" style="flex-direction: column;" appDnd
                        [class.dragging]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                        (drop)="isDismissable ? '' : onFileDropped($event)">
                        <input type="file" #fileDropRef id="fileDropRef2" (change)="onAdditional($event)"
                            [disabled]="isDismissable" multiple accept="image/*, application/pdf" hidden />

                        <label for="fileDropRef2" class="upload-label" [class.disabled]="isDismissable">
                            <div>
                                <span class="mb-2">Drag and drop files here or click to upload</span>
                            </div>
                        </label>
                    </div>

                    <!-- Mobile Scan Option -->
                    <!-- <div *ngIf="isMobile" class="mobile-scan mt-2">
                        <label for="cameraInput" class="camera-upload-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="1.5">
                                    <path
                                        d="M12.857 3.189h-1.714c-.681 0-1.022 0-1.331.094c-.274.083-.529.22-.75.401c-.25.205-.438.489-.816 1.056L7.103 6.454c-1.524 0-2.286 0-2.868.296a2.72 2.72 0 0 0-1.188 1.19c-.297.581-.297 1.343-.297 2.867v5.651c0 1.524 0 2.286.297 2.868c.26.512.677.928 1.188 1.189c.582.296 1.344.296 2.868.296h9.794c1.524 0 2.286 0 2.868-.296a2.72 2.72 0 0 0 1.188-1.19c.297-.581.297-1.343.297-2.867v-5.651c0-1.524 0-2.286-.297-2.868a2.72 2.72 0 0 0-1.188-1.189c-.582-.296-1.344-.296-2.868-.296L15.754 4.74c-.378-.567-.567-.85-.816-1.056a2.2 2.2 0 0 0-.75-.401c-.309-.094-.65-.094-1.331-.094" />
                                    <path d="M15.775 13.212a3.775 3.775 0 1 1-7.55 0a3.775 3.775 0 0 1 7.55 0" />
                                </g>
                            </svg>&nbsp;
                            Scan Using Camera
                        </label>
                        <input type="file" id="cameraInput" (change)="onAdditional($event.target)" accept="image/*"
                            capture="environment" hidden [disabled]="isDismissable" />
                    </div> -->

                    <!-- Display Uploaded Files -->
                    <div *ngIf="uploadedFiles.length > 0" class="uploaded-file-list mt-2">
                        <div *ngFor="let file of uploadedFiles; let i = index" class="uploaded-file-item">
                            <span>{{ file.name }}</span>
                            <button (click)="removeFile(i)" class="remove-file-button">✖</button>
                        </div>
                    </div>
                </div>


                <div *ngIf="renderForm === RenderFrom.REQUEST">
                    <div class="form-row full-width">
                        <mat-checkbox formControlName="consentToShareData" required>
                            *I {{userName}} agree to share the medical information on behalf of {{
                            patientForm.get('firstName')?.value
                            }} {{ patientForm.get('lastName')?.value }}.
                        </mat-checkbox>
                    </div>
                </div>

            </div>
        </form>
    </section>

    <section mat-dialog-actions class="d-flex justify-content-end">
        <div class="modal-buttons-container d-flex gap-2">
            <button class="secondaryBtn" (click)="closeDialog()">
                <span class="btnContent">Cancel</span>
            </button>
            <button class="primaryBtn" (click)="submitForm()" [disabled]="patientForm.invalid || isSubmitLoading">
                <span class="btnContent">
                    Submit
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                        *ngIf="isSubmitLoading">
                        <path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="1.5"
                            d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12">
                            <animateTransform attributeName="transform" attributeType="XML" dur="1.26s" from="0,12,12"
                                repeatCount="indefinite" to="360,12,12" type="rotate" />
                        </path>
                    </svg>
                </span>
            </button>
        </div>
    </section>

</div>